/**
 * Assistant API 的稳定领域契约。
 * 本文件只声明前端使用的模型和 DTO，不包含请求、响应解析或运行时逻辑。
 */

export interface AssistantUserTurn {
  content: string
  conversationId?: string
  tools: Array<any>
  systemPrompt?: string
}

export interface AssistantToolResultTurn {
  conversationId: string
  runId: string
  toolCallId: string
  content: Record<string, unknown>
}

export interface HarnessPendingToolCall {
  toolCallId: string
  kind: string
  name: string
  arguments: Record<string, unknown>
  batchId: string | null
  requiresConfirmation: boolean
  parameterFingerprint: string | null
}

export interface HarnessRunView {
  conversationId: string
  runId: string
  status: string
  pendingToolCalls: HarnessPendingToolCall[]
  finalReply: string | null
  usage?: Record<string, unknown> | null
  error?: Record<string, unknown> | null
  lastEventSeq?: number
  stateVersion?: number
}

export type AssistantStreamEvent =
  | {
      type: 'queued' | 'accepted'
      conversationId?: string
      runId: string
      queueSequence?: number
      queuePosition?: number
    }
  | { type: 'start'; conversationId: string; runId: string }
  | {
      type: 'message_delta'
      conversationId: string
      runId: string
      content: string
    }
  | { type: 'requires_action'; run: HarnessRunView }
  | { type: 'done'; run: HarnessRunView }
  | {
      type: 'error'
      conversationId?: string
      runId?: string
      code?: string
      message: string
    }
  | {
      type: 'diagnostic'
      event: 'tool_call' | 'tool_result' | 'compression' | string
      data: unknown
    }

export interface HarnessSseFrame {
  event: string
  data: string
}

export interface HarnessEnvelope<T> {
  success: boolean
  data: T
  errorCode?: string
  error?: string
  message?: string
  detail?: string
}

export interface GuiguiAgentToken {
  access_token: string
  token_type: 'Bearer'
  expires_in: number
  idle_timeout: number
}

export interface HarnessFetchInit {
  method?: string
  body?: unknown
  headers?: Record<string, string>
  signal?: AbortSignal
  fetchImpl?: typeof fetch
}

export interface AssistantConversationQuery {
  santiType?: string
  lifeformId?: string
  cursor?: string
  limit?: number
}

export interface AssistantConversationSummary {
  conversationId: string
  lifeformId: string
  title: string
  updatedAt: string
  isPinned: boolean
}

export interface AssistantConversationPage {
  items: AssistantConversationSummary[]
  nextCursor: string | null
}

export interface AssistantMessageQuery {
  includeTools?: boolean
  cursor?: string
  limit?: number
}

export interface AssistantMessage {
  id: string
  role: string
  content: string
  createdAt: string
  source: string
}

export interface AssistantMessagePage {
  conversationId: string
  items: AssistantMessage[]
  nextCursor: string | null
}

export interface HarnessRunEvent {
  eventSeq: number
  eventKey: string
  type: string
  data: unknown
}

export interface HarnessRunEventPage {
  conversationId: string
  runId: string
  items: HarnessRunEvent[]
}

export interface HarnessCancelResult {
  conversationId: string
  runId: string
  status: string
  stateVersion: number
}
